<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { QuotationStore } from '../stores'

    import QuotationsService from '../$services/requests.service'
    import GoogleMapsMethods from '../$methods/google.maps.methods'

    import PackageSelect from '../packages/package.select.svelte'
    import LocationOptions from '../locations/location.options.svelte'
    import SearchBox from '../$components/google.searchbox.svelte'
    import Button from '../$components/button.svelte'
    import Map from '../$components/google.map.svelte'

    const dispatch = createEventDispatcher()

    export let data = {}
    export let quotation = {}
    export let findQuotations = false

    let loading = false
    let map = null

    let inputs = {
        pickup: null,
        delivery: null
    }

    let markers = {
        pickup: null,
        delivery: null
    }

    async function onLoad(event) {

        map = event.detail

        if(data.pickup.zipcode)
            onSelected({detail: data.pickup}, 'pickup')

        if(data.delivery.zipcode)
            onSelected({detail: data.delivery}, 'delivery')
    }

    async function createQuotation() {
        try {

            loading = true
            const resp = await QuotationsService.createQuotation(data)
            loading = false

            if(!resp.success)
                return toast({message: resp.error.message, type: 'is-danger'})

            QuotationStore.set(resp.data)
            dispatch('success', resp.data)

        } catch(error) {
            loading = false
            console.log(error)
        }
    }

    async function findQuotation() {
        try {

            loading = true
            const resp = await QuotationsService.findQuotation(data)
            loading = false

            if(!resp.success)
                return toast({message: resp.error.message, type: 'is-danger'})
            
            quotation = resp.data
            dispatch('success', resp.data)

        } catch(error) {
            loading = false
            console.log(error)
        }
    }

    async function onSelected(event, markerName) {

        const location = event.detail

        const input = inputs[markerName]
        let marker = markers[markerName]

        if(!marker)
            marker = GoogleMapsMethods.Marker(map, {draggable: true})

        marker.setPosition(location.coordinates)
        marker.setEvent('dragend', async event => {

            const location = await GoogleMapsMethods.Geocode({
                location: {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng(),
                }
            })

            input.value = location.address
            markerRefresh(markerName, location)
        })

        input.value = location.address

        markers[markerName] = marker
        markerRefresh(markerName, location)
    }

    function markerRefresh(markerName, location) {

        data[markerName] = location

        const marker = markers[markerName]

        const content = `
            <b>${ markerName === 'pickup'? 'Origen' : 'Destino' }</b><br>
            <small>${ location.address }</small>
        `

        marker.openWindow(location.coordinates, content)

        if(markers.pickup && markers.delivery)
            return GoogleMapsMethods.CenterMarkers(map, [markers.pickup, markers.delivery])

        if(markers.pickup)
            return map.setCenter(markers.pickup.getPosition())

        if(markers.delivery)
            return map.setCenter(markers.delivery.getPosition())
    }

    function onLocationUpdated(event, locationName) {
        data[locationName] = event.detail
    }

</script>

<div class="title is-3">Cotización</div>
<hr>
<div class="columns">
    <div class="column is-5">
        <label for="" class="label">Elije la zona de origen</label>
        <LocationOptions bind:location={ data.pickup } on:selected={event => onSelected(event, 'pickup')} />
        <SearchBox bind:input={inputs.pickup} bind:location={data.pickup} 
            on:change={event => onSelected(event, 'pickup')} 
            on:updated={event => onLocationUpdated(event, 'pickup')} 
        />
        <label for="" class="label">Elije la zona de destino</label>
        <LocationOptions bind:location={ data.delivery } on:selected={event => onSelected(event, 'delivery')} />
        <SearchBox bind:input={inputs.delivery} bind:location={data.delivery} 
            on:change={event => onSelected(event, 'delivery')} 
            on:updated={event => onLocationUpdated(event, 'delivery')} 
        />
        <br>
        <div class="title is-3">Paquete</div>
        <hr>
        <PackageSelect bind:ipackage={data.package} />
        <hr>
        {#if !findQuotations}
            <Button on:click={ createQuotation } text="Cotizar" icon="dollar-sign" color="primary" fullwidth { loading } />
        {:else}
            <Button on:click={ findQuotation } text="Cotizar" icon="dollar-sign" color="primary" fullwidth { loading } />
        {/if}
    </div>
    <div class="column">
        <label for="" class="label">Selecciona la zonas de origen y destino</label>
        <Map on:load={onLoad} height="660px" width="660px"/>
        <div class="message is-info">
            <div class="message-body">
                Nota: puedes mover los pines para indicar con mas precisión la dirección de origen y destino.
            </div>
        </div>
    </div>
</div>